export default __webpack_public_path__ + "static/media/wrench-2.b559ee55.png";